// Copyright © 2021 Move Closer
/**
 *
 * Background color for module
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export var ModuleBackgroundColor;
(function (ModuleBackgroundColor) {
    ModuleBackgroundColor["Accent"] = "accent";
    ModuleBackgroundColor["Blue"] = "blue";
    ModuleBackgroundColor["Brown"] = "brown";
    ModuleBackgroundColor["DarkGray"] = "dark_gray";
    ModuleBackgroundColor["DarkGreen"] = "dark_green";
    ModuleBackgroundColor["Gray"] = "gray";
    ModuleBackgroundColor["Green"] = "green";
    ModuleBackgroundColor["Navy"] = "navy";
    ModuleBackgroundColor["None"] = "none";
    ModuleBackgroundColor["Yellow"] = "yellow";
    ModuleBackgroundColor["Custom"] = "custom";
    ModuleBackgroundColor["WhiteGray"] = "white_gray";
})(ModuleBackgroundColor || (ModuleBackgroundColor = {}));
/**
 *
 * Mapping [ModuleBackgroundColor] with appropriate class names
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @see ModuleBackgroundColor
 */
export const moduleClassesMap = {
    [ModuleBackgroundColor.Accent]: 'module__colored__accent',
    [ModuleBackgroundColor.Blue]: 'module__colored__blue',
    [ModuleBackgroundColor.Brown]: 'module__colored__brown',
    [ModuleBackgroundColor.DarkGray]: 'module__colored__darkgray',
    [ModuleBackgroundColor.DarkGreen]: 'module__colored__darkgreen',
    [ModuleBackgroundColor.Gray]: 'module__colored__gray',
    [ModuleBackgroundColor.Green]: 'module__colored__green',
    [ModuleBackgroundColor.Navy]: 'module__colored__navy',
    [ModuleBackgroundColor.None]: 'module',
    [ModuleBackgroundColor.Yellow]: 'module__colored__yellow',
    [ModuleBackgroundColor.Custom]: 'module__colored__custom',
    [ModuleBackgroundColor.WhiteGray]: 'module__colored__whitegray'
};
/**
 * Additional number of rows in 4 TeaserBox versions : '6S-thumbnails-list', '6S-big-thumbnails-list', '6S-text-list', '6T-text-list'
 *
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
export var ModuleAdditionalRows;
(function (ModuleAdditionalRows) {
    ModuleAdditionalRows["None"] = "none";
    ModuleAdditionalRows["addOne"] = "+1";
    ModuleAdditionalRows["addTwo"] = "+2";
})(ModuleAdditionalRows || (ModuleAdditionalRows = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var ModuleDriver;
(function (ModuleDriver) {
    ModuleDriver["About"] = "about";
    ModuleDriver["Anchor"] = "anchor";
    ModuleDriver["AdBanner"] = "ad_banner";
    ModuleDriver["AnonymousReport"] = "anonymous_report";
    ModuleDriver["ArticleTeaser"] = "article_teaser";
    ModuleDriver["ArticlesList"] = "articles_list";
    ModuleDriver["AuthorCard"] = "author_card";
    ModuleDriver["Blockquote"] = "blockquote";
    ModuleDriver["Boxes"] = "boxes";
    ModuleDriver["Contact"] = "contact";
    ModuleDriver["DataSet"] = "data_set";
    ModuleDriver["EditorialOffice"] = "editorial_office";
    ModuleDriver["Embed"] = "embed";
    ModuleDriver["Experts"] = "experts";
    ModuleDriver["FullpageAd"] = "fullpage_ad";
    ModuleDriver["Gallery"] = "gallery";
    ModuleDriver["HR"] = "hr";
    ModuleDriver["HTML"] = "html";
    ModuleDriver["Heading"] = "heading";
    ModuleDriver["HeadingCountdown"] = "heading_countdown";
    ModuleDriver["Hero"] = "hero";
    ModuleDriver["Image"] = "image";
    ModuleDriver["InfoBar"] = "info_bar";
    ModuleDriver["Legacy"] = "legacy";
    ModuleDriver["List"] = "list";
    ModuleDriver["LiveFeed"] = "live_feed";
    ModuleDriver["Logos"] = "logos";
    ModuleDriver["NewsBar"] = "news_bar";
    ModuleDriver["Newsletter"] = "newsletter";
    ModuleDriver["Pagination"] = "pagination";
    ModuleDriver["Paragraph"] = "paragraph";
    ModuleDriver["Partners"] = "partners";
    ModuleDriver["Paywall"] = "paywall";
    ModuleDriver["Quotes"] = "quotes";
    ModuleDriver["Quotations"] = "quotations";
    ModuleDriver["RandomImage"] = "random_image";
    ModuleDriver["ReadMore"] = "read_more";
    ModuleDriver["RelatedArticles"] = "related_articles";
    ModuleDriver["RequestAccess"] = "request_access";
    ModuleDriver["StickyBar"] = "sticky_bar";
    ModuleDriver["TeaserBox"] = "teaser_box";
    ModuleDriver["Testimonials"] = "testimonials";
    ModuleDriver["Tile"] = "tile";
    ModuleDriver["Presentation"] = "presentation";
    ModuleDriver["HeadingNav"] = "heading_nav";
})(ModuleDriver || (ModuleDriver = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var SimpleModuleDriver;
(function (SimpleModuleDriver) {
    SimpleModuleDriver["AdBanner"] = "ad_banner";
    SimpleModuleDriver["Anchor"] = "anchor";
    SimpleModuleDriver["Blockquote"] = "blockquote";
    SimpleModuleDriver["DataSet"] = "data_set";
    SimpleModuleDriver["Embed"] = "embed";
    SimpleModuleDriver["Form"] = "request_access";
    SimpleModuleDriver["Gallery"] = "gallery";
    SimpleModuleDriver["HR"] = "hr";
    SimpleModuleDriver["HTML"] = "html";
    SimpleModuleDriver["Heading"] = "heading";
    SimpleModuleDriver["HeadingCountdown"] = "heading_countdown";
    SimpleModuleDriver["Image"] = "image";
    SimpleModuleDriver["Legacy"] = "legacy";
    SimpleModuleDriver["List"] = "list";
    SimpleModuleDriver["Paragraph"] = "paragraph";
    SimpleModuleDriver["Paywall"] = "paywall";
    SimpleModuleDriver["RandomImage"] = "random_image";
    SimpleModuleDriver["ReadMore"] = "read_more";
})(SimpleModuleDriver || (SimpleModuleDriver = {}));
/**
 * Determine if given module should allow user to set non concrete data.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var ModuleMode;
(function (ModuleMode) {
    ModuleMode["Default"] = "default";
    ModuleMode["Layout"] = "layout";
    ModuleMode["Smart"] = "smart";
})(ModuleMode || (ModuleMode = {}));
